<section class="auth-layout">
  <aside class="auth-layout__aside">
    <img
      [ngSrc]="'assets/images/bg-login-img.png'"
      alt="image de fond"
      class="auth-layout__aside__bg-img"
      fill="true"
      priority="true"
    />

    <article class="auth-layout__aside-content">
      <div class="auth-layout__aside-content-slider">
        @for (slide of slides; let i = $index; track i) {
          @if (i === currentSlideIndex()) {
            <section class="active">
              <h2 class="auth-layout__aside-content-slider-title">
                {{ slide.title }}
              </h2>
              <p class="auth-layout__aside-content-slider-description">
                {{ slide.description }}
              </p>
            </section>
          }
        }

        <div class="auth-layout__aside-content-slider__navigation">
          @for (dot of slides; let i = $index; track i) {
            <button
              class="auth-layout__aside-content-slider__navigation-dot"
              [class.auth-layout__aside-content-slider__navigation-dot--active]="
                i === currentSlideIndex()
              "
              (click)="goToSlide(i)"
              [attr.aria-label]="'Aller à la slide ' + (i + 1)"
            ></button>
          }
        </div>

        <div class="auth-layout__aside-content-slider__branding"></div>
      </div>
    </article>
  </aside>

  <main class="auth-layout__main relative overflow-hidden">
    <div class="auth-layout__decorative-shape"></div>
    <div class="auth-layout__main-content">
      <router-outlet></router-outlet>
    </div>
    <footer class="auth-layout__main-footer" aria-label="Login footer">
      <app-copyright />
    </footer>
  </main>
</section>
